import React, { useState, useEffect, useRef, useMemo } from 'react';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeeMonthlyTracking.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { getDistrict, getProject, getStates, fetchMonths, getEmployeeSummaryDrilldownFullDetails, getEmployeSatateAndDistrictWise, fetchMonthsCurrent } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter } from '../../../utils/validations';
import { getPostedAndRelievedCount, getPostedAndRelievedCountDrilldown, getPostedAndRelievedCountDistDrilldown, getTrackingMonthlyDetails } from '../../../services/employeePostingService';
import { format } from 'date-fns';
import {
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Cell,
    ZAxis,
} from 'recharts';
const EmployeeMonthlyTracking = () => {
    const currentYear = new Date().getFullYear();
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [month, setMonth] = useState(null);
    const [year, setYear] = useState(currentYear);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([]);
    const [attendanceData, setAttendanceData] = useState([]);
    const [holidaySet, setHolidaySet] = useState(new Set());
    const [project, setProject] = useState(null);
    const [employeeOptions, setEmployeeoptions] = useState([]);
    const [employee, setemployee] = useState(null);
    const [clients, setClients] = useState(1);
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        month: false,
        year: false,
    });
    const [errors, setErrors] = useState({});
    const yearInputRef = useRef(null);

    const [hasFetched, setHasFetched] = useState(false); // New state to track fetch attempt
    const isFetchDataEnabled = state && month && year && employee && district;




    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);




    useEffect(() => {
        const loadMonths = async () => {
            try {
                const months = await fetchMonthsCurrent(year);
                setMonthOptions(months);
            } catch (error) {
                console.error("Error fetching months:", error);
                setErrors((prev) => ({ ...prev, general: "Failed to load months" }));
            }
        };
        loadMonths();
    }, [year]);


    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            // if (!effectRan.current) {
            fetchDistricts();
            // }
            // return () => {
            //     effectRan.current = true;
            // }

        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);
    useEffect(() => {
        if (district) {
            const fetchingEmployees = async () => {
                try {
                    const data = await getEmployeSatateAndDistrictWise(state, district);
                    setEmployeeoptions(
                        data.map(emp => ({
                            value: emp.employeeUniqueId,
                            label: `${emp.employeeName} -${emp.contactNumber} - ${emp.designation}`,
                        }))
                    );
                } catch (error) {
                    console.log("District or state missing", error);
                }
            };
            fetchingEmployees();
        } else {
            setEmployeeoptions([]);
            setemployee(null);
        }
    }, [district, state]);




    // Clear attendance data and fetch status when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        // setOriginalData([]);
        setHasFetched(false);
    }, [state, district, month, year,]); // ✅ Add project to depende

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setMonth(null);
                setClients(null);
                setProject(null); // ✅ Clear project when state changes

                break;
            case 'district':
                setDistrict(value);
                // setProject(null); // ✅ Clear project when district changes
                break;
            case 'employee':
                setemployee(value);
                break;
            case 'month':
                setMonth(value);
                break;

            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const handleYearChange = (date) => {
        setYear(date ? date.getFullYear() : null);
        setErrors(prev => ({ ...prev, year: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!month) newErrors.month = 'Month is required';
        if (!year) newErrors.year = 'Year is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const data = await getTrackingMonthlyDetails(state, district, employee, year, month,)

            const employeeData = data.dailyReports || [];

            setAttendanceData(employeeData);

        } catch (error) {
            //console.error("Error fetching reportmonthlytrack data:", error);
            // setErrors((prev) => ({
            //     ...prev,
            //     general: "Failed to fetch reportmonthlytrack data",
            // }));
            alert("Failed to fetch reportmonthlytrack data. Please try again.");
        }
    };


    // const currentYear = new Date().getFullYear();
    const minDate = new Date(2000, 0, 1);
    const maxDate = new Date(currentYear, 11, 31);

    const classifyDay = (dayObj, holidaySet = new Set()) => {
        if (!dayObj) return 'working';

        const status = (dayObj.attendanceStatus || '').toLowerCase();

        // Check explicit attendance statuses from API data first
        if (status.includes('holiday')) return 'holiday';
        if (status.includes('week off') || status.includes('week-off')) return 'weekoff';

        // Fallback: check date via JS for Sundays or holidays if needed
        if (dayObj.date) {
            const d = new Date(dayObj.date);
            const iso = format(d, 'yyyy-MM-dd');

            if (holidaySet.has(iso)) return 'holiday';
            if (d.getDay() === 0) return 'weekoff';
        }

        return 'working';
    };

    const buildMonthlyScatterData = (attendanceData, holidaySet) => {
        const points = [];
        attendanceData.forEach((day, dayIdx) => {
            const dayType = classifyDay(day, holidaySet); // Pass the full `day` object

            day.timeline?.forEach((hourBlock, hourIdx) => {
                hourBlock.slots?.forEach((slot, slotIdx) => {
                    const slotIndex = hourIdx * 2 + slotIdx;
                    const records = slot.records || [];
                    const has = records.length > 0;
                    const dist = records.reduce(
                        (sum, r) => sum + (r.distanceFromPreviousMeters || 0),
                        0
                    );

                    points.push({
                        dayIdx,
                        dayLabel: day.date ? format(new Date(day.date), 'dd-MM-yyyy') : '',
                        location: day.locationName || '',
                        status: day.attendanceStatus || '',
                        dayType,
                        slotIndex,
                        dayPosition: dayIdx,
                        has,
                        dist,
                        timeLabel: slot.timeWindow,
                        recordCount: records.length,
                    });
                });
            });
        });
        return points;
    };

    const scatterData = useMemo(
        () => buildMonthlyScatterData(attendanceData, holidaySet),
        [attendanceData, holidaySet]
    );

    const dayLabels = useMemo(
        () =>
            attendanceData.map((d, i) =>
                d.date
                    ? `${format(d.date, 'dd-MM')}`
                    : `${i + 1}. Day ${i + 1}`
            ),
        [attendanceData]
    );

    return (
        <div className="monthlytrack-reportmonthlytrack-container">
            <div className="monthlytrack-reportmonthlytrack-box">
                <h2 className="monthlytrack-reportmonthlytrack-heading">Employee Monthly Tracking</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={handleSubmit}
                >
                    <div className="monthlytrack-reportmonthlytrack-maincontainer">
                        <div className="monthlytrack-reportmonthlytrack-container-part">
                            <div className={`monthlytrack-reportmonthlytrack-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === state) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="monthlytrack-reportmonthlytrack-container-part">
                            <div className={`monthlytrack-reportmonthlytrack-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === district) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label> <span className="required">*</span> District</label>
                                {/* {errors.district && <div className="error-message">{errors.district}</div>} */}
                            </div>
                        </div>
                    </div>
                    <div className="monthlytrack-reportmonthlytrack-maincontainer">

                        <div className="monthlytrack-reportmonthlytrack-container-part">
                            <div className={`monthlytrack-reportmonthlytrack-floating-label-container ${isFocused.employee || employee ? 'float-label' : ''}`}>
                                <Select
                                    name='employee'
                                    options={employeeOptions}
                                    value={employeeOptions.find(opt => opt.value === employee) || null}
                                    onChange={option => handleInputChange(option, 'employee')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, employee: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, employee: false }))}
                                    placeholder=" "
                                    isClearable={!district}
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label> <span className="required">*</span> Employee</label>
                            </div>
                        </div>
                        <div className="monthlytrack-reportmonthlytrack-container-part">
                            <div className={`monthlytrack-reportmonthlytrack-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="monthlytrack-reportmonthlytrack-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div>
                        </div>

                    </div>



                    <div className="monthlytrack-reportmonthlytrack-maincontainer">


                        <div className="monthlytrack-reportmonthlytrack-container-part">
                            <div className={`monthlytrack-reportmonthlytrack-floating-label-container ${isFocused.month || month ? 'float-label' : ''}`}>
                                <Select
                                    name="month"
                                    options={monthOptions}
                                    value={monthOptions.find(opt => opt.value === month) || null}
                                    onChange={option => handleInputChange(option, 'month')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, month: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, month: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Month</label>
                                {errors.month && <div className="error-message">{errors.month}</div>}
                            </div>
                        </div>

                        <div className="monthlytrack-reportmonthlytrack-container-part">
                            {/* <div className={`monthlytrack-reportmonthlytrack-floating-label-container ${isFocused.year || year ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={year ? new Date(year, 0, 1) : null}
                                    onChange={handleYearChange}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, year: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, year: false }))}
                                    dateFormat="yyyy"
                                    showYearPicker
                                    placeholderText=""
                                    className="monthlytrack-reportmonthlytrack-date-picker"
                                    minDate={minDate}
                                    maxDate={maxDate}
                                    ref={yearInputRef}

                                    title="Select a year"
                                />
                                <label><span className="required">*</span>Year</label>
                                {errors.year && <div className="error-message">{errors.year}</div>}
                            </div> */}
                        </div>

                    </div>



                    <div className="monthlytrack-reportmonthlytrack-btn-div">
                        <button type="submit" className="monthlytrack-reportmonthlytrack-btn"
                            disabled={!isFetchDataEnabled}


                        >
                            Generate Report
                        </button>
                    </div>
                </form>
            </div>


            {attendanceData.length > 0 && (
                <div className="reportrarel-chart-container">
                    <h3 className="reportrarel-chart-title">
                        Hourly Distance Deviation by Day
                    </h3>

                    <ResponsiveContainer
                        width="100%"
                        height={Math.max(700, attendanceData.length * 22)}
                    >
                        <ScatterChart
                            margin={{ top: 30, right: 60, left: 90, bottom: 100 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" stroke="#ececec" />

                            {/* X = days of the month */}
                            <XAxis
                                type="number"
                                dataKey="dayPosition"
                                domain={[-0.5, attendanceData.length - 0.5]}
                                ticks={attendanceData.map((_, i) => i)}
                                tickFormatter={(v) => dayLabels[v] || ''}
                                interval={0}
                                width={180}
                                angle={-30}
                                textAnchor="end"
                                height={140}
                                tick={{ fontSize: 11, fill: '#1f2937', fontWeight: 500 }}
                                label={{
                                    value: 'Day of Month',
                                    position: 'insideBottom',
                                    offset: -10,
                                    style: {
                                        fontSize: 13,
                                        fill: '#374151',
                                        fontWeight: 600,
                                        textAnchor: 'middle',
                                    },
                                }}
                            />

                            {/* Y = 48 half-hour slots */}
                            <YAxis
                                type="number"
                                dataKey="slotIndex"
                                domain={[-0.5, 47.5]}
                                ticks={Array.from({ length: 24 }, (_, i) => i * 2)}
                                tickFormatter={(v) => {
                                    const h = Math.floor(v / 2);
                                    return `${String(h).padStart(2, '0')}:00`;
                                }}
                                interval={0}
                                width={70}
                                tick={{ fontSize: 11, fill: '#374151', fontWeight: 500 }}
                                label={{
                                    value: 'Time of Day',
                                    angle: -90,
                                    position: 'insideLeft',
                                    offset: 10,
                                    style: {
                                        fontSize: 13,
                                        fill: '#374151',
                                        fontWeight: 600,
                                        textAnchor: 'middle',
                                    },
                                }}
                            />

                            <ZAxis range={[80, 80]} />

                            <Tooltip
                                cursor={{ strokeDasharray: '3 3' }}
                                content={({ active, payload }) => {
                                    if (!active || !payload?.length) return null;
                                    const p = payload[0].payload;
                                    const hasRecords = p.recordCount > 0;

                                    return (
                                        <div className="reportrarel-chart-tooltip">
                                            <div className="tooltip-title">
                                                {p.dayLabel}
                                                {p.dayType === 'holiday' && ' · Holiday'}
                                                {p.dayType === 'weekoff' && ' · Weekoff'}
                                            </div>
                                            <div className="tooltip-sub">
                                                {p.location} · {p.status}
                                            </div>
                                            <hr />

                                            <div className="tooltip-row">
                                                <span>Slot</span>
                                                <span>{p.timeLabel}</span>
                                            </div>

                                            {hasRecords ? (
                                                <>
                                                    <div className="tooltip-row">
                                                        <span>Records</span>
                                                        <span>{p.recordCount}</span>
                                                    </div>
                                                    <div className="tooltip-row">
                                                        <span>Distance</span>
                                                        <span
                                                            className={`tooltip-distance ${p.dist > 0.5
                                                                ? 'tooltip-distance--danger'
                                                                : 'tooltip-distance--normal'
                                                                }`}
                                                        >
                                                            {p.dist.toFixed(2)} m
                                                        </span>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="tooltip-empty">No record</div>
                                            )}
                                        </div>
                                    );
                                }}
                            />

                            <Scatter
                                data={scatterData}
                                shape="square"
                                isAnimationActive={false}
                            >
                                {scatterData.map((p, i) => {
                                    let fill = '#ffffff';        // empty → white
                                    let stroke = '#e0e0e0';

                                    if (p.dayType === 'holiday') {
                                        fill = '#ffc107';          // 🟨 yellow
                                        stroke = '#e0a800';
                                    } else if (p.dayType === 'weekoff') {
                                        fill = '#fd7e14';          // 🟧 orange
                                        stroke = '#d9660f';
                                    } else if (p.has && p.dist > 0.5) {
                                        fill = '#dc3545';          // 🟥 red
                                        stroke = '#fff';
                                    } else if (p.has) {
                                        fill = '#28a745';          // 🟩 green
                                        stroke = '#fff';
                                    }

                                    return (
                                        <Cell
                                            key={i}
                                            fill={fill}
                                            stroke={stroke}
                                            strokeWidth={0.5}
                                        />
                                    );
                                })}
                            </Scatter>
                        </ScatterChart>
                    </ResponsiveContainer>

                    <div className="reportrarel-chart-legend">
                        <span className="legend-item">
                            <span className="legend-box green" /> no deviation
                        </span>
                        <span className="legend-item">
                            <span className="legend-box red" /> &gt; 0.5 km (deviation)
                        </span>
                        <span className="legend-item">
                            <span
                                className="legend-box white"
                                style={{ border: '1px solid #e0e0e0' }}
                            />{' '}
                            Empty record
                        </span>
                        <span className="legend-item">
                            <span className="legend-box yellow" /> Holiday
                        </span>
                        <span className="legend-item">
                            <span className="legend-box orange" /> Weekoff
                        </span>
                    </div>
                </div>
            )}

            <div className="reportmonthlytrack-table-monthlt-att-container">
                <table className="reportmonthlytrack-table-monthlt-att">
                    <thead>
                        {/* Top header row: S.No, Employee Name, Location + Hours 1-24 */}
                        <tr>
                            <th rowSpan="3" className="sticky-col sno-col">S.No</th>
                            <th rowSpan="3" className="sticky-col name-col">Date</th>
                            <th rowSpan="3" className="sticky-col loc-col">Location</th>
                            <th rowSpan="3" className="sticky-col loc-col">Attendance Status</th>
                            <th colSpan="48" className="deviation-header">
                                Deviation From Job Location
                            </th>

                        </tr>



                        {/* Row 2: Hour headers */}
                        <tr>
                            {Array.from({ length: 24 }, (_, i) => (
                                <th key={i + 1} colSpan="2" className="hour-header">
                                    {String(i).padStart(2, '0')}:00 – {String(i + 1).padStart(2, '0')}:00 hr
                                </th>
                            ))}
                        </tr>

                        {/* Row 3: 30-min sub-headers */}
                        <tr>
                            {Array.from({ length: 24 }, (_, i) => (
                                <React.Fragment key={`sub-${i}`}>
                                    <th className="sub-header">00 – 30 min</th>
                                    <th className="sub-header">30 – 60 min</th>
                                </React.Fragment>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {attendanceData.length > 0 ? (
                            attendanceData.map((employee, empIdx) => (
                                <tr key={employee.employeeUniqueId || empIdx} className="clickable-row">
                                    <td className="sticky-col sno-col">{empIdx + 1}</td>
                                    <td className="sticky-col name-col">{format(employee.date, 'dd-MM-yyyy')}</td>
                                    <td className="sticky-col loc-col">{employee.locationName}</td>
                                    <td className="sticky-col loc-col">{employee.attendanceStatus}</td>

                                    {employee.timeline?.map((hourBlock) =>
                                        hourBlock.slots?.map((slot) => {
                                            const firstRecord = slot.records?.[0];
                                            const rawValue = firstRecord?.distanceFromPreviousMeters;

                                            return (
                                                <td
                                                    key={slot.timeWindow}
                                                    className={`distance-cell ${rawValue ? "has-distance" : ""}`}
                                                    title={`${slot.timeWindow} | Records: ${slot.records?.length || 0} | Distance: ${rawValue ?? 0}`}
                                                >
                                                    {rawValue !== undefined && rawValue !== null ? `${rawValue} km` : "-"}
                                                </td>
                                            );
                                        })
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="51" className="no-data-cell">
                                    No data available. Please generate a report.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>



        </div>
    );
};

export default EmployeeMonthlyTracking;